var _defs, _path, _path2, _rect, _rect2, _path3, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDocModal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdd9c9;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#fff;}.cls-3,.cls-5{fill:none;stroke-width:1.5px;}.cls-3{stroke:#727d79;}.cls-4{fill:#727d79;}.cls-5{stroke:#f2892c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,50A25,25,0,1,0,0,25,25,25,0,0,0,25,50Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.31,36.89H10.69A2.14,2.14,0,0,1,8.75,34.6V15.4a2.14,2.14,0,0,1,1.94-2.29H39.31a2.14,2.14,0,0,1,1.94,2.29V34.6A2.14,2.14,0,0,1,39.31,36.89Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.75,
    y: 12.75,
    width: 32.5,
    height: 24.5,
    rx: 3.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 12.39,
    y: 31.45,
    width: 16.15,
    height: 1.73,
    rx: 0.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.26,27.35H36.17a.87.87,0,0,1,.87.87h0a.87.87,0,0,1-.87.87H13.26a.87.87,0,0,1-.87-.87h0A.87.87,0,0,1,13.26,27.35Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 13.11,
    y: 16.72,
    width: 24.5,
    height: 7.5,
    rx: 1.25
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDocModal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-doc-modal.eadcd87dab4b84ba9ee2aac145f674f5.svg";